export const CAPABILITY_CREDENTIAL_UPDATE = "CredentialUpdate" as const;

export function supportsCredentialUpdate(dto: {
  capabilities?: string[] | null;
}): boolean {
  return dto.capabilities?.includes(CAPABILITY_CREDENTIAL_UPDATE) ?? false;
}
